import BaseViewController from "./base-view-controller";
import buildCareTeamProviders from "./helpers/care-team-provider-list";

class CareTeamMembersListController extends BaseViewController {
  preprocessScreenData() {
    if (
      !this.appData.isPulse &&
      !this.appData.careTeamProviderDetailFieldsData?.length
    ) {
      this.appData.setDetailCareTeamProviderFieldsData(
        this.appData.data.screens.find(
          screen => screen.identifier === "CareTeamProfileDetailScreen"
        )?.fields
      );
    }

    const providerList = (
      buildCareTeamProviders(
        this.screen.data?.list_data,
        this.components,
        (name, text, action) =>
          this.onViewProfileButtonClick(name, text, action),
        this.screen.action
      ) || []
    ).map(provider => ({ type: "raw", el: provider }));
    this.screen = {
      ...this.screen,
      fields: [...this.screen.fields, ...providerList]
    };
  }

  onViewProfileButtonClick(provider, action) {
    const { name, care_team_relation_id } = provider;

    this.appData.setDetailProviderData(
      this.screen.data.list_data.find(
        providerItem => providerItem.detail_data.name === name
      ).detail_data
    );

    super.handleButtonClick(
      "care_team_relation_id",
      care_team_relation_id,
      action
    );
  }

  handleButtonClick(name, text, action, history, initialScreen, eventStates) {
    const replaceHistory = history || 0;

    if (name === "providerProfileLink" && action?.data?.templated_list) {
      const { data } = action.data.templated_list;
      this.appData.setDetailProviderData(data);
    }

    super.handleButtonClick(
      name,
      text,
      action,
      replaceHistory,
      initialScreen,
      eventStates
    );
  }
}

export default CareTeamMembersListController;
